// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"624f2fc0","72":"87e880d3","84":"2bf7ce98","302":"89566b3f","325":"f01cde68","381":"9adab5e1","511":"36ed57a2","826":"476a7b69","992":"d7a3947b"}[chunkId] + ".chunk.js";
};